<script setup lang="ts">
import type {
  IEmblaButtonsProps,
  IEmblaButtonsEmits,
} from '@/shared/ui/EmblaCarousel/model/types/emblaCarousel';

const props = withDefaults(defineProps<IEmblaButtonsProps>(), {
  isNext: false,
  isDisabled: false,
});

const emit = defineEmits<IEmblaButtonsEmits>();

const icon: ComputedRef<string> = computed(() =>
  props.isNext ? 'ArrowRight' : 'ArrowLeft',
);
const classes: ComputedRef<string> = computed(() => (props.isNext ? '_next' : '_prev'));
const ariaLabel: ComputedRef<string> = computed(() =>
  props.isNext ? 'Следующий слайд' : 'Предыдущий слайд',
);

const handlerClick = (): void => {
  emit('click', props.isNext ? 'next' : 'prev');
};
</script>

<template>
  <button
    :class="['slider-arrow', classes]"
    :disabled="isDisabled"
    :aria-label="ariaLabel"
    type="button"
    @click="handlerClick"
  >
    <AppIcon :name="icon" />
  </button>
</template>

<style lang="less">
.slider-arrow {
  background: white;
  box-shadow:
    -@main-size -5px 25px rgba(0, 0, 0, 0.06),
    0px @size-x10 @size-x10 -18px rgba(139, 144, 164, 0.2);
  border-radius: @main-size;
  position: absolute;
  width: 32px;
  height: 32px;
  z-index: 2;
  transform: translateY(-50%);
  transition: @A all;
  top: 50%;
  padding: 0;
  border: none;

  &:not(:disabled) {
    cursor: pointer;
  }

  &::before {
    display: none;
  }

  &:disabled {
    opacity: 0;
  }

  &._prev {
    left: 0;
  }

  &._next {
    right: 0;
  }
}
</style>
